module.exports = __webpack_public_path__ + "media/garage-door-installtion.6e4f1e58.mp4";